import { render, staticRenderFns } from "./QuestionEdit.vue?vue&type=template&id=c1a3b2c0"
import script from "./QuestionEdit.vue?vue&type=script&lang=js"
export * from "./QuestionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports